import { FETCHED_ALL, FETCHED_ONE, REMOVED, FETCHED_DEFAULT } from './action'

export default function reducer(state = { entities: {}, result: [] }, action = {}) {
  const { payload = {}, type } = action
  const { result, entities } = payload

  switch (type) {
    case FETCHED_ALL:
      return {
        ...state,
        entities: {
          ...entities.addresses,
        },
        result: [...result],
      }
    case FETCHED_ONE:
      return {
        ...state,
        entities: {
          ...state.entities,
          [result]: entities.addresses[result],
        },
      }
    case REMOVED:
      return {
        ...state,
        result: state.result.filter(id => id !== result)
      }
    case FETCHED_DEFAULT:
      return {
        ...state,
        entities: {
          ...state.entities,
          [result]: entities.addresses[result],
        },
      }
    default:
      return state
  }
}
